import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es la orientación por fMRI en SAINT®?",
    answer:
      "Antes de iniciar SAINT®, se realiza una resonancia magnética funcional (fMRI) para localizar el circuito cerebral asociado con la depresión en cada persona. Esta orientación individualizada distingue a SAINT® de la TMS convencional, que utiliza un punto de estimulación estándar.",
  },
  {
    question: "¿Por qué importa la orientación por fMRI?",
    answer:
      "La orientación por fMRI permite adaptar la estimulación al circuito de cada persona. SAINT® combina esta orientación individualizada con estimulación theta burst y un calendario acelerado de cinco días.",
  },
];

export const esFmriGuided = makeEsArticle({
  slug: "fmri-guided-tms-for-depression",
  title: "TMS con orientación por fMRI para la depresión",
  description:
    "La TMS con orientación por fMRI localiza el circuito cerebral asociado con la depresión en cada persona. SAINT® combina esta orientación individualizada con estimulación theta burst y un calendario de cinco días.",
  h1: "TMS con orientación por fMRI para la depresión",
  breadcrumbLabel: "TMS con orientación por fMRI",
  shortAnswer:
    "La TMS con orientación por fMRI utiliza una resonancia magnética funcional para localizar el circuito cerebral asociado con la depresión en cada persona, en lugar de un punto de estimulación estándar. SAINT® combina esta orientación individualizada con estimulación theta burst y un calendario acelerado de cinco días. La orientación por fMRI es una de las diferencias clave entre SAINT® y la TMS convencional.",
  keyTakeaways: [
    "La orientación por fMRI localiza el circuito cerebral de cada persona.",
    "SAINT® combina orientación por fMRI con estimulación theta burst.",
    "SAINT® se administra durante cinco días.",
    "La orientación individualizada distingue a SAINT® de la TMS convencional.",
    "La TMS convencional utiliza un punto de estimulación estándar.",
  ],
  sections: [
    {
      heading: "Orientación individualizada",
      paragraphs: [
        "La TMS convencional utiliza un punto de estimulación estándar basado en medidas anatómicas generales. La orientación por fMRI, en cambio, localiza el circuito cerebral asociado con la depresión en cada persona mediante una resonancia magnética funcional.",
        "SAINT® utiliza esta orientación individualizada para adaptar la estimulación al circuito de cada persona.",
      ],
    },
    {
      heading: "Estimulación theta burst",
      paragraphs: [
        "SAINT® combina la orientación por fMRI con estimulación theta burst, un patrón de estimulación de alta frecuencia que se administra en ráfagas cortas, en lugar de la estimulación convencional continua.",
      ],
    },
    {
      heading: "Calendario acelerado",
      paragraphs: [
        "SAINT® administra 50 sesiones durante cinco días. La orientación por fMRI, la estimulación theta burst y el calendario acelerado son los tres elementos que distinguen a SAINT® de la TMS convencional.",
        "[[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
